import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import {
  FaShoppingBag,
  FaSearch,
  FaCoins,
  FaRegUser,
  FaQuestionCircle,
} from "react-icons/fa";
import { CiDeliveryTruck, CiHeart } from "react-icons/ci";
import { MdOutlineAccountCircle } from "react-icons/md";
import { TbLogout } from "react-icons/tb";
import AddCoinsModal from "../AddCoinsModal";
import AccountInfoPanel from "../Account/AccountInfoPanel";
import TopBar from "../TopBar";
import BottomBar from "./BottomBar";
import Footer from "./Footer";
import ProfilePictureUpload from "./ProfilePicComponent";
import coinsImg from "../Assets/Coin.jpg.png";
import Login from "./Login";
import xianheLogo from "../Assets/newlogo.png";
// import xianheLogo from "../Assets/logo_goldenlf.png";
// import xianheLogo from "../Assets/logo_lotus_fairy_2.png";
import { FaShoppingCart } from "react-icons/fa";
import NotificationsModal from "../NotificationsModal";
import { useTranslation } from "react-i18next";
import galaxyBg from "../Assets/Xianhe New Assets/bg.png";

const Tryoutpage = () => {
  const { t } = useTranslation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [coins, setCoins] = useState(0);
  const [comcoins, setComCoins] = useState(0);
  const [panelVisible, setPanelVisible] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const userID = localStorage.getItem("userID");
  const [cartItemCount, setCartItemCount] = useState(0);
  const mainRef = useRef(null);
  const bgRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation(); // Add this to track current route

  // Check if user is on cart page
  const isOnCartPage = location.pathname === '/cart';

  // On mobile, checkout closes with its own sticky Total / Place Order bar,
  // so the site footer underneath it would just be noise. On desktop the
  // page uses a Lazada-style two-column layout with a sticky sidebar instead
  // of a viewport-pinned bar, so the footer is shown and reachable by
  // scrolling.
  const isOnCheckoutPage = location.pathname === '/checkout';

  // Consolidated effect: login state + coin fetch + mobile/tablet detection
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 852);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024);
  useEffect(() => {
    const checkLogin = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      const roleType = localStorage.getItem("roletype");
      const name = localStorage.getItem("name") || "User";
      const shortenedName =
        name.length > 12 ? name.substring(0, 12) + "..." : name;
      setIsLoggedIn(loggedIn);
      if (loggedIn) {
        setUsername(shortenedName);
        if (roleType === "Master") {
          window.location.href = "/mainmasters"; // keep existing redirect logic
        }
      }
    };

    const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`;
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) throw new Error("Failed to fetch data");
        const data = await response.json();
        setCoins(data[0].COINS);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    checkLogin();

    const handleResize = () => {
      // Lightweight resize listener for breakpoints
      const w = window.innerWidth;
      setIsMobile(w <= 852);
      setIsTablet(w <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [userID]);

  useEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl) return;

    const handleScroll = () => {
      if (bgRef.current) {
        bgRef.current.style.transform = `translateY(${-mainEl.scrollTop}px)`;
      }
    };

    mainEl.addEventListener('scroll', handleScroll, { passive: true });
    return () => mainEl.removeEventListener('scroll', handleScroll);
  }, []);

  // Add this new useEffect to track cart count
  // useEffect(() => {
  //   const fetchCartCount = async () => {
  //     try {
  //       const cartRes = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/booking/getCart?ID=${userID}`
  //       );
  //       if (!cartRes.ok) return;
        
  //       const cartData = await cartRes.json();
  //       if (Array.isArray(cartData) && cartData.length > 0) {
  //         const parsedCart = JSON.parse(cartData[0]?.CART || "[]");
  //         const totalItems = parsedCart.reduce((sum, item) => sum + (item.Quantity || 1), 0);
  //         setCartItemCount(totalItems);
  //       } else {
  //         setCartItemCount(0);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching cart count:", error);
  //       setCartItemCount(0);
  //     }
  //   };

  //   if (userID && isLoggedIn) {
  //     fetchCartCount();

  //     // ✅ Listen for cart updates in current tab
  //     const handleCartUpdate = () => {
  //       fetchCartCount();
  //     };
  //     window.addEventListener('cartUpdated', handleCartUpdate);

  //     // ✅ Listen for cart updates from other tabs
  //     const handleStorage = (e) => {
  //       if (e.key === "cartUpdatedAt") {
  //         fetchCartCount();
  //       }
  //     };
  //     window.addEventListener('storage', handleStorage);

  //     // Optional: poll every 30 seconds as backup
  //     const interval = setInterval(fetchCartCount, 30000);

  //     return () => {
  //       window.removeEventListener('cartUpdated', handleCartUpdate);
  //       window.removeEventListener('storage', handleStorage);
  //       clearInterval(interval);
  //     };
  //   }
  // }, [userID, isLoggedIn]);

  // Add this effect to update cart count on route change
  useEffect(() => {
    const fetchCartCount = async () => {
      try {
        // Use the same endpoint as Shop.jsx's addToCart
        const cartRes = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Usercart/GetUserCart?CustId=${userID}`
        );
        if (!cartRes.ok) return;

        const cartData = await cartRes.json();
        //console.log("Cart data fetched:", cartData); // Debug log
        
        if (Array.isArray(cartData) && cartData.length > 0) {
          const totalItems = cartData.reduce((sum, item) => sum + (item.Qty || 1), 0);
          //console.log("Total cart items:", totalItems); // Debug log
          setCartItemCount(totalItems);
        } else {
          setCartItemCount(0);
        }
      } catch (error) {
        console.error("Error fetching cart count:", error);
        setCartItemCount(0);
      }
    };

    if (userID && isLoggedIn) {
      fetchCartCount();

      const handleCartUpdate = () => {
        //console.log("Cart update event received"); // Debug log
        fetchCartCount();
      };
      window.addEventListener('cartUpdated', handleCartUpdate);

      const handleStorage = (e) => {
        if (e.key === "cartUpdatedAt") {
          //console.log("Storage cart update detected"); // Debug log
          fetchCartCount();
        }
      };
      window.addEventListener('storage', handleStorage);

      // Reduce polling interval for more responsive updates
      const interval = setInterval(fetchCartCount, 3000);

      return () => {
        window.removeEventListener('cartUpdated', handleCartUpdate);
        window.removeEventListener('storage', handleStorage);
        clearInterval(interval);
      };
    } else {
      setCartItemCount(0); // Clear badge when logged out
    }
  }, [userID, isLoggedIn, location.pathname]);
  
  // Add this new useEffect to update gems when purchase is made
  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        if (!response.ok) return;
        const data = await response.json();
        setCoins(data[0].COINS);
      } catch (error) {
        console.error("Error fetching gems:", error);
      }
    };

    if (userID && isLoggedIn) {
      // ✅ Listen for gem updates after purchase
      const handleGemsUpdate = () => {
        fetchCoins();
      };
      
      window.addEventListener('gemsUpdated', handleGemsUpdate);
      
      return () => {
        window.removeEventListener('gemsUpdated', handleGemsUpdate);
      };
    }
  }, [userID, isLoggedIn]);
  
  const handleAddComCoins = (comamount) => {
    const newComCoins = comcoins + comamount;
    setComCoins(newComCoins);
    localStorage.setItem("comcoins", newComCoins);
  };

  // Restored: logout handler used in profile dropdown
  // Clear all client-side storage (localStorage, sessionStorage, cookies, caches, IndexedDB)
  const clearAllClientStorage = async () => {
    try {
      // Optionally preserve language preference (if set)
      const lang = localStorage.getItem("language") || localStorage.getItem("languageId");
      localStorage.clear();
      if (lang) localStorage.setItem("language", lang);
    } catch (e) {
      // ignore
    }

    try {
      sessionStorage.clear();
    } catch (e) {
      // ignore
    }

    try {
      // Delete all cookies by setting expiry in the past
      document.cookie.split(";").forEach((c) => {
        try {
          const name = c.split("=")[0].trim();
          document.cookie = `${name}=;expires=${new Date(0).toUTCString()};path=/`;
        } catch (e) {
          // ignore per-cookie failures
        }
      });
    } catch (e) {
      // ignore
    }

    try {
      // Clear service worker caches if available
      if (window.caches && caches.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (e) {
      // ignore
    }

    try {
      // Attempt to remove all IndexedDB databases (best-effort)
      if (indexedDB && indexedDB.databases) {
        const dbs = await indexedDB.databases();
        await Promise.all(dbs.map((db) => indexedDB.deleteDatabase(db.name)));
      }
    } catch (e) {
      // ignore - indexedDB.databases() may not be supported in all browsers
    }

    try {
      // Notify other tabs that a logout happened
      localStorage.setItem("loggedOutAt", Date.now().toString());
    } catch (e) {
      // ignore
    }
  };

  const handleLogout = async () => {
    try {
      await clearAllClientStorage();
    } catch (e) {
      // fallback: try targeted removals
      try {
        localStorage.removeItem("username");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("coins");
        localStorage.removeItem("comcoins");
        localStorage.removeItem("userID");
        localStorage.removeItem("roletype");
        localStorage.removeItem("name");
      } catch (err) {
        // ignore
      }
    }

    setIsLoggedIn(false);
    setUsername("");
    setCoins(0);
    setComCoins(0);

    // Redirect to main and reload to ensure all in-memory state resets
    navigate("/main");
    // Give React a tick to navigate before reload (best-effort)
    setTimeout(() => window.location.reload(), 80);
  };

  const handleDropdownToggle = () => {
    if (!isScrolling) {
      setIsDropdownVisible((prevVisible) => !prevVisible); // Toggle dropdown visibility
    }
  };

  const handleDropdownHide = () => setIsDropdownVisible(false);
  const handleToggle = () => setPanelVisible(!panelVisible);

  const dropdownStyle = useMemo(
    () => ({
      display: isDropdownVisible ? "block" : "none",
      position: "fixed", // Changed from absolute to fixed
      top: "60px", // Position below the header (header height)
      right: isMobile ? "8px" : "150px", // Align to right edge with padding
      backgroundColor: "black",
      color: "#DFBD69",
      border: "1px solid #DFBD69",
      minWidth: isMobile ? "200px" : "260px",
      maxWidth: isMobile ? "280px" : "320px",
      boxShadow: "0px 8px 16px 0px rgba(255, 215, 0, 0.25)",
      padding: "10px",
      zIndex: 1200,
      borderRadius: "10px",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      transition: "opacity 0.2s ease, transform 0.2s ease",
      opacity: isDropdownVisible ? 1 : 0,
      transform: isDropdownVisible ? "translateY(0)" : "translateY(-4px)",
      pointerEvents: isDropdownVisible ? "auto" : "none",
      willChange: "opacity, transform",
    }),
    [isDropdownVisible, isMobile]
  );

  const mainStyle = {
    flex: 1,
    overflowY: "auto",
    display: 'flex',
    flexDirection: 'column',
    // display: isMobile ? "block" : "none",
    position: 'relative',
    zIndex: 0,
  };

  const handleBellHover = () => {};

  const handleBellLeave = () => {};

  const handleQuestionHover = () => {};

  const handleQuestionLeave = () => {};

  const [isScrolling, setIsScrolling] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-myspace-trigger]')) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false); // Close dropdown on outside click
      }
    };

    const handleScroll = () => {
      if (isMobile) {
        setIsScrolling(true);
        setIsDropdownVisible(false); // Close dropdown on mobile scroll

        // Allow user to reopen the dropdown after a short delay when scrolling stops
        setTimeout(() => {
          setIsScrolling(false);
        }, 300); // Adjust this delay as needed
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const handleOpenSignInPanel = () => {
      setIsModalOpen(true);
    };

    window.addEventListener("openSignInPanel", handleOpenSignInPanel);
    return () => window.removeEventListener("openSignInPanel", handleOpenSignInPanel);
  }, []);

  return (
    <div style={layoutStyle}>
      <div
        ref={bgRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "600px",        // header + full greeting area
          backgroundImage: `url(${galaxyBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          opacity: 1,
          zIndex: 0,
          pointerEvents: "none",
          willChange: "transform", 
          
          // Add these lines to create the fade-out effect at the bottom:
          WebkitMaskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
          maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
        }}
      />
      <style>{`
        /* Custom scrollbar styles */
        .profilePic {
          min-width: 32px;
          min-height: 32px;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          background: #fff;
          flex-shrink: 0;
        }

        .logoImg {
          min-width: 40px;
          max-height: 40px;
          margin-left: 8px;
          object-fit: contain;
          opacity: 0.95;
        }

        /* Tablet and below: keep profile pic and logo fixed size */
        @media (max-width: 1200px) {
          .profilePic {
            width: 32px;
            height: 32px;
            min-width: 32px;
            min-height: 32px;
            margin-right: 8px;
          }
          .logoImg {
            min-width: 40px;
            max-height: 40px;
            margin-left: 8px;
          }
        }

        /* Mobile: stack or adjust spacing if needed */
        @media (max-width: 768px) {
          .profilePic {
            width: 32px;
            height: 32px;
            margin-right: 4px;
          }
          .logoImg {
            margin-left: 4px;
          }
        }

        /* Checkout scrolls normally, but the track would run alongside the
           sticky Total / Place Order bar, so keep the scrollbar out of sight. */
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
      `}</style>
      <header style={{ ...headerStyle, height: 'auto', paddingRight: 0 }}>
        <TopBar
          cartCount={cartItemCount}
          isLoggedIn={isLoggedIn}
          onCartClick={() => navigate('/cart')}
          onMySpaceClick={handleDropdownToggle}
          onSignInClick={toggleModal}
          coins={coins}
          onLogout={handleLogout}
        />
      </header>

      {/* Profile dropdown — position:fixed so it renders above all content */}
      {isLoggedIn && (
        <div ref={dropdownRef}>
          <div style={dropdownStyle} role="menu" aria-hidden={!isDropdownVisible}>
            <div style={iconContainerStyle}>
              <div style={coinsBoxStyle}>
                <img src={coinsImg} alt="Gems" style={{ height: "50%" }} />{" "}
                {coins} {t('tryoutpage.gems')}
              </div>
            </div>
            <div style={iconContainerStyle}></div>
            <div style={additionalContentStyle}>
              <button style={buttonStyle} onClick={() => navigate('/account')}>
                {t('tryoutpage.account')}
              </button>
              <Link to="/purchasehistory" style={linkbuttonStyle}>
                {t('tryoutpage.history')}
              </Link>
              <button style={buttonStyle} onClick={handleLogout}>{t('tryoutpage.logout')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Login modal — position:fixed, safe to render anywhere in the tree */}
      {isModalOpen && (
        <>
          <div style={{ position: "fixed", top: 0, right: 0, width: isMobile ? "100vw" : "30vw", height: "100%", backgroundColor: "black", boxShadow: "0 0 10px rgba(0,0,0,0.5)", transform: "translateX(0)", transition: "transform 0.3s ease-in-out", zIndex: 10000 }}>
            <button onClick={toggleModal} style={{ position: "absolute", top: "10px", right: "10px", backgroundColor: "black", border: "none", fontSize: "18px", cursor: "pointer", color: "#DFBD69", display: isMobile ? "none" : "block" }}>
              Log in
            </button>
            <Login onClose={toggleModal} />
          </div>
          <div onClick={toggleModal} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: isMobile ? "black" : "rgba(0,0,0,0.5)", zIndex: 9999 }} />
        </>
      )}

      {/* Notifications (floating, manages its own position) */}
      {/* {isLoggedIn && <NotificationsModal />} */}

      <main
        ref={mainRef}
        style={mainStyle}
        className={(isOnCheckoutPage || isOnCartPage) && isMobile ? "hide-scrollbar" : undefined}
      >
        {/* Galaxy background overlay — sits above solid-colored children */}
        {/* <div
          style={{
            position: "absolute",
            top: -60,
            left: 0,
            width: "100%",
            height: "16%",
            backgroundImage: `url(${galaxyBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center top",
            opacity: 0.15,          // tune 0.08–0.20 to taste
            zIndex: 1,              // above child page content
            pointerEvents: "none",  // never captures clicks/touches
          }}
        /> */}
        {/* Overlay logo (absolute, no layout shift) */}
        {/* <div
          style={{
            position: 'absolute',
            top: '-4px',
            right: '100px',
            zIndex: 5,
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            display: isMobile ? 'none' : 'block'
            // display: window.innerWidth <= 1024 ? 'none' : 'block'
          }}
        >
          <Link to="/" style={{ textDecoration: 'none', pointerEvents: 'auto' }}>
            <img
              src={xianheLogo}
              alt="Logo"
              style={{
                maxHeight: 120,
                width: 40,
                objectFit: 'fill',
                display: 'block',
                opacity: 0.95,
                //backgroundColor: 'white',
              }}
            />
          </Link>
        </div> */}
        {/* Removed duplicate mobile TopBar here; it's now embedded on the left side of the header */}

        {panelVisible && (
          <AccountInfoPanel
            onToggle={handleToggle}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              width: "300px",
              height: "100vh",
              backgroundColor: "#fff",
              boxShadow: "-2px 0 5px rgba(0,0,0,0.2)",
              padding: "20px",
              zIndex: 1200,
            }}
          />
        )}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </div>
        {/* On mobile the cart and checkout pages pin their action bar to the
            bottom of the viewport, which would sit on top of the footer — so
            the footer is dropped there, but kept on desktop. */}
        {(!isMobile || (!isOnCartPage && !isOnCheckoutPage)) && <Footer />}
      </main>
    </div>
  );
};

const layoutStyle = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  width: "100vw",
  margin: 0,
  overflowX: "hidden",
  position: "relative",
  height: "100vh",
  backgroundColor: "#171520",
};

// const layoutStyle = {
//   display: "flex",
//   flexDirection: "column",
//   minHeight: "100vh",
//   width: "100vw",
//   margin: 0,
//   overflowX: "hidden",
//   position: "relative",
//   height: "100vh",
//   backgroundColor: "#171520",           // dark fallback
//   backgroundImage: `url(${galaxyBg})`,  // galaxy on the root wrapper
//   backgroundSize: "cover",
//   backgroundPosition: "center top",
//   backgroundAttachment: "scroll",
  
// };

const headerStyle = {
  //backgroundColor: "rgba(23, 21, 32, 0.85)",  // matches #171520 with slight transparency
  // paddingLeft: '10px',
  display: "flex",
  justifyContent: "space-between", // Keep left and right pinned for stable mobile/tablet layout
  paddingRight: "10px",
  height: "60px",
  //boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)", // Stronger shadow
  // backgroundColor: 'red'
  position: "relative",
  zIndex: 23000,
  isolation: "isolate",
  backgroundColor: "transparent",
};

const overallcontainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  flexWrap: "nowrap",
  minWidth: 120,
  overflowX: "auto", // Allow horizontal scroll if needed
  whiteSpace: "nowrap", // Prevent wrapping/squishing
  gap: "6px",
};

const userBoxStyle = {
  position: "relative",
  cursor: "pointer",
  overflow: "visible", // Added to ensure dropdown isn't clipped
};

const iconContainerStyle = {
  display: "flex",
  justifyContent: "space-evenly",
  marginTop: "10px",
  marginLeft: "5px",
};

const dropdownItemStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "4px",
  minWidth: "64px",
};

const iconLabelStyle = {
  color: "#DFBD69",
  fontSize: "12px",
  lineHeight: "1",
  userSelect: "none",
};

const coinsBoxStyle = {
  backgroundColor: "black",
  border: "1px solid #ddd",
  borderRadius: "5px",
  padding: "8px 12px",
  margin: "0 5px",
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "bold",
  flex: "1",
  justifyContent: "center",
  alignContent: "center",
  flexDirection: "row",
  height: "50px",
};

const dropdownIconStyle = {
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  padding: "10px",
  borderRadius: "50%",
  transition: "background-color 0.3s ease, transform 0.3s ease",
  fontSize: "24px",
  color: "#DFBD69",
};

const linkdropdownIconStyle = {
  ...dropdownIconStyle,
  color: "#DFBD69",
};

const additionalContentStyle = {
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  marginTop: "15px",
  alignItems: "stretch",
  justifyContent: "space-between",
  flexWrap: "nowrap",
  overflowX: "auto",
};

const LocationBtn = {
  backgroundColor: "#ffffff",
  border: "1px solid #dcdcdc",
  padding: "5px 10px",
  borderRadius: "5px",
  cursor: "pointer",
  marginRight: "15px",
};

const buttonStyle = {
  backgroundColor: "black",
  border: "1px solid #dcdcdc",
  padding: "5px 12px",
  borderRadius: "5px",
  cursor: "pointer",
  color: "#DFBD69",
  fontSize: "14px",
  flex: 1,
  whiteSpace: "nowrap",
  textAlign: "center",
};

const linkbuttonStyle = {
  backgroundColor: "black",
  border: "1px solid #dcdcdc",
  padding: "5px 12px",
  borderRadius: "5px",
  cursor: "pointer",
  color: "#DFBD69",
  fontSize: "14px",
  textDecoration: "none",
  flex: 1,
  whiteSpace: "nowrap",
  textAlign: "center",
};

export default Tryoutpage;
